import React from 'react';

const LoadingComponent = () => (
  <div className="loading-wrapper">
    <div className="spinner-ring" />
    <p className="loading-text">Cooking something delicious…</p>
  </div>
);

export default LoadingComponent;
